export type SyncLastOutcome =
  | 'fast_ok'
  | 'warn_metadata_phase'
  | 'warn_assets_pending'
  | 'done_with_warnings'
  | 'remote_pull_recovery'
  | 'noop_remote_unverified'
  | null

export type SyncStatusKind = 'review_required' | 'info' | null

export function classifySyncStatusMessage(message?: string): SyncStatusKind {
  if (!message) return null
  if (
    /sync segura/i.test(message)
    || /revisa opciones/i.test(message)
    || /revisa antes de ejecutar/i.test(message)
    || /recuperar cambios remotos/i.test(message)
  ) {
    return 'review_required'
  }
  return 'info'
}

